import { connect } from 'react-redux';
import { BUILDER, FACILITY_INFO } from '../../../../../src/shared/abilities';
import withTheme from '../../../../../src/web/theme/withTheme';
import compose from '../../../../../src/web/utils/react/compose';
import facilityWidget from '../../../../../src/web/components/widgets/decorators/facilityWidget';
import editor from '../../../../../src/web/components/widgets/decorators/editor';
import { getPageLocale } from '../../../../../src/web/store/modules/page';
import { createHelpLink } from '../../../../../src/web/components/HelpLink';
import SMFacilityInformation from './SMFacilityInformation';
import Editor from './Editor';
import { NAME, ID } from './properties';

const component = compose(
  connect(
    state => ({
      pageLocale: getPageLocale(state),
    }),
  ),
  facilityWidget(
    { name: NAME, category: 'Facility', componentId: ID },
    {
      defaults: {
        header: {
          blocks: [
            {
              key: 'db2mm',
              text: 'Facility Header',
              type: 'header-one',
              depth: 0,
              inlineStyleRanges: [],
              entityRanges: [],
            },
          ],
          entityMap: {},
        },
        description: {
          blocks: [
            {
              key: 'db2mm',
              text: [
                'Packing tape trailer hitch rent truck certified dealer.',
                'Large aisle ground floor park here. 24-hour access for your crates. Closet space',
                'room in your driveway. Your document storage safe clean happy secure. Priceless',
                'family keepsakes grandmother\'s ashes.',
              ].join(' '),
              type: 'unstyled',
              depth: 0,
              inlineStyleRanges: [],
              entityRanges: [],
            },
          ],
          entityMap: {},
        },
      },
      menu:
       {
         items: [
           createHelpLink({
             urlFn: ({ corporateUrl }) => `${corporateUrl}settings/corporate/facility-info`,
             text: 'facility info',
             authorization: { action: 'manage', subject: [BUILDER, FACILITY_INFO] },
           }),
           'edit',
           'delete',
         ],
       },
    },
  ),
  editor(Editor),
  withTheme,
)(SMFacilityInformation);

component.authorization = {};

export default component;
